module.exports = __webpack_public_path__ + "img/Mask Group@2x.9e71c3cc.jpg";